<template>
<div class="uix-tree-selected">
  <ui-button v-if="selected.id" type="flat" color="primary" @click.prevent="clearSelected" icon="highlight_off" style="float:right">Usuń wybór</ui-button>

  <p class="name">
    <strong v-if="selected.id">{{ selected.name }}</strong> <strong v-if="!selected.id">&mdash;</strong>
  </p>
</div>
</template>
<script>
export default {
  props: ['selected'],
  methods: {
    clearSelected () {
      this.$dispatch('tree-clear-selected')
    }
  }
}
</script>


// WEBPACK FOOTER //
// TreeSelected.vue?2934b95e